import { z } from 'zod';

export const slackChannelMessageDto = z.object({
  channel: z.string().min(1),
  text: z.string().min(1),
});

export type SlackChannelMessageDto = z.infer<typeof slackChannelMessageDto>;
